<template>
  <leftCenterRightContainer class="register-warp" :showRight="false" v-loading.fullscreen.lock="loading"
    :element-loading-text="loadingText">
    <div slot="left" class="register-left" :class="searchAll ? 'disabled' : ''">
      <div class="left-search">
        <el-input @input="doctorSearch" v-model="doctorSearchFrom.doctorName" placeholder="搜索医生"
          prefix-icon="el-icon-search" clearable></el-input>
      </div>
      <div class="calender-warp">
        <calendar ref="calendar" @changeMonth="changeMonth" @currenDate="getCurrenDate">
          <div slot="title" class="calender-title">门诊</div>
        </calendar>
      </div>
      <div class="left-doctor-list">
        <div v-if="doctorList.length > 0">
          <div :class="currenDoctor.doctorId == item.doctorId ? 'active list-item' : 'list-item'"
            v-for="item in doctorList" :key="item.schedulingItemId" @click="changeDoctor(item)">
            <div :class="currenDoctor.doctorId == item.doctorId ? 'active item-name' : 'item-name'">{{ item.doctorName
            }}
            </div>
            <div>已约{{ item.regNum }}</div>
            <div>待签{{ item.staySignNum }}</div>
            <div>待诊{{ item.staySeeNum }}</div>
            <div>候补{{ item.standbyNum || 0 }}</div>
            <custom-button type="info" :disabled="item.status == '1'" @click.stop="openRegister(item)" size="mini"
              v-if="computedDate(item.schedulingTime)">{{ item | filterStatus }}</custom-button>
          </div>
        </div>
        <div v-else class="noData">暂无排班</div>
      </div>
    </div>
    <div slot="center" class="register-right">
      <div class="right-top">
        <div class="top-left">
          <custom-button :disabled="searchAll" type="info" size="medium" style="width:100px"
            @click="toDay">查看今日</custom-button>
          <el-input class="ml10" @input="searchRegisterList" clearable v-model="patinetSearchForm.searchValue"
            prefix-icon="el-icon-search" placeholder="患者姓名/手机号码"></el-input>
        </div>
        <div class="top-title">
          <span>{{ currenDoctor.doctorName }}</span>
          <span class="color6671 size16">
            <template v-if="currenDoctor.signinPolicy === 'default'">(按预约顺序看诊)</template>
            <template v-if="currenDoctor.signinPolicy === 'time_span'">(按时间段内的签到顺序看诊)</template>
            <template v-if="currenDoctor.signinPolicy === 'signin_date'">(按签到顺序看诊)</template>
          </span>
        </div>
        <div class="top-right">
          <span v-show="currenDoctor.clinicName">坐诊诊室：</span>
          <span v-show="currenDoctor.clinicName" class="rehister-price">{{ currenDoctor.clinicName }}</span>
        </div>
      </div>
      <div class="right-content">
        <div class="content-top" :class="searchAll ? 'disabled' : ''">
          <el-radio-group size="mini" v-model="patinetSearchForm.fakeStatus" @input="sttusChange">
            <el-radio-button v-for="item in statusList" :key="item.value" :label="item.value">{{ item.label }}
              ({{ item.num }})</el-radio-button>
            <el-radio-button label="99">候补单({{ standbyNum || 0}})</el-radio-button>
          </el-radio-group>
          <div class="top-right" v-if="patinetSearchForm.fakeStatus !='99'">
            <span>挂号费：</span>
            <span class="rehister-price">¥{{ totalPriceTotal }}</span>
          </div>
        </div>
        <div class="customTable scroll-loadmore" v-loadMore="getMoreList">
          <customTable :tableData="tableData" :showPages="false"
            :column="patinetSearchForm.fakeStatus == '99' ? waitColumn : column"
            :header-cell-style="{ background: '#F0F1F3' }" @cell-click="cellClick">
            <template slot="status" slot-scope="{ row } ">
              <div v-if="row.status == '-5'">取消</div>
              <div v-else class="status-warp">
                <div v-for="item in statusList" :key="item.value">
                  <div v-if="item.value == row.status" :style="{ color: item.fontColor }">{{ row.status | filterRegStatus }}</div>
                </div>
                <div v-if="row.referralStatus" class="referral-status">(已转诊)</div>
              </div>
            </template>
            <template slot="patientName" slot-scope="{ row } ">
              <div style="display: flex; justify-content: center; align-items: center;">
                <div style="color: #1890FF;">{{ row.patientName }}</div>
                <div v-if="row.channelType == 60">(美团)</div>
              </div>
            </template>
            <template slot="registeredCode" slot-scope="{ row } ">
              <div>{{ row.registeredCode ? `${row.timeName}${row.registeredCode}` : '-' }}</div>
            </template>
            <template slot="price" slot-scope="{ row } ">
              <div>¥{{ row.price }}</div>
            </template>
            <template this.patinetSearchForm.fakeStatus = '99' slot="waitStatus" slot-scope="{ row } ">
                <div :style="{'color':waitStatus[row.status].color }">{{ waitStatus[row.status].label }}</div>
            </template>
          </customTable>
        </div>
      </div>
      <div>
        <div v-for="item in levelData" :key="item.name">
          <div v-if="visibleObj[item.name]">
            <component :is="item.dialog" v-if="visibleObj[item.name]" :ref="item.ref" :visibleObj="visibleObj"
              :showCancelPayBtn="showCancelPayBtn" @cancelPayingStatusHandle="cancelPayingStatusHandle"
              @refresh="refresh" @close="dialogVisible" @updateData="confirmUpdateData"
              @refundMoenyRegister="refundMoenyRegister" @refundRegister="refundRegister" :dialogObj="dialogObj"
              @print="print" @signAndCall="signAndCall" @sign="sign" @chargeAndSign="chargeAndSign" @changeRegister="changeRegister"
              @closeLokset="closeLokset" @yibaoPay="yibaoPay">
            </component>
          </div>
        </div>
      </div>
      <VipCardScan ref="vipCardScan" @scanSuccess="vipCardScanSuccess"></VipCardScan>
      <!-- 打印 -->
      <printDialog :printDialogShow="printDialogShow" v-show="printDialogShow"
        @closePrintPrescription="closePrintPrescription" ref="printDia" @setPrintDiaShow="setPrintDiaShow"
        @printSuccess="printSuccess" :id="printOrderId" :orderType="'0'" :printType="'1'"></printDialog>
      <!-- 短信验证弹框 -->
      <SMS-verification ref="SMSDialog" v-if="SMSDialogObj.show" :show="SMSDialogObj.show" @close="SMSDialogClose"
        :dialogObj="SMSDialogObj" @smsVerificationConfirm="smsVerificationConfirm"></SMS-verification>
      <waitDetail-dialog :waitDialogObj="waitDialogObj" v-if="waitDialogObj.show" @close="waitDetailClose"></waitDetail-dialog>
    </div>
  </leftCenterRightContainer>
</template>

<script>
import leftCenterRightContainer from '@/components/leftCenterRightContainer'
import customTable from '@/components/customTable/customTable'
import calendar from '@/components/calendar/index'
import registerDialog from '@/views/Registration/component/registerDialog/registerDialog.vue'
import locksetDialog from '@/views/Registration/component/lockset/lockset.vue'
import chargeDialog from '@/views/Registration/component/chargeDialog/index'
import VipCardScan from '@/components/VipCard/VipCardScan.vue'
import { levelData, visibleObj } from '@/components/js/dialog'
import howmuchDialog from '@/components/howmuchDialog/index'
import { Utils } from '@/utils/utils'
import refundDialog from '@/views/Registration/component/refundDialog/refundDialog'
import returnComfirmDialog from '@/views/Registration/component/returnComfirmDialog/returnComfirmDialog'
import registerDetailDialog from '@/views/Registration/component/registerDetailDialog/registerDetailDialog'
import { doctorSchedulingList, getRegisterStatusNum, getRegisterList, registerSignIn, getInfo } from '@/api/register'
import { getVipCardInfo } from "@/api/member"
import { isEmptyArray, isNull, dictText, debounce, isNullObj, timeoutTimer, msgboxWarning } from '@/utils/validateBase'
import { registerAdd, print, registerCancel, saveRelation, getStandbyList } from "@/api/registration"; // 挂号请求
import { outpatientTypeList, registerStatusList, doctorVisitList } from '@/utils/const'
import { payDTO, CommonDTO } from '@/DTO/index'
import { completeOrder } from '@/api/pricingDetails'
import printDialog from '@/components/printDialog'
import moment from 'moment';
import SMSVerification from '@/components/SMSVerification'
import { getWalletAmount } from '@/api/wallet'
import { getShareCoupon } from '@/api/coupon';
import waitDetailDialog from './component/waitDetailDialog/waitDetailDialog'
import { color } from 'echarts'
import yibaoDialog from '@/views/Pricing/components/yibaoDialog.vue'
export default {
  // 定义引入的组件
  components: {
    printDialog,
    returnComfirmDialog,
    leftCenterRightContainer,
    customTable,
    calendar,
    registerDialog,
    locksetDialog,
    chargeDialog,
    howmuchDialog,
    VipCardScan,
    refundDialog,
    registerDetailDialog,
    SMSVerification,
    waitDetailDialog,
    yibaoDialog
  },
  props: {},
  data() {
    return {
      loading: false,
      showCancelPayBtn: false, // 是否显示取消支付按钮
      isShowAllDocotor: true,//是否显示全部医生
      patinetSearchForm: {
        deptId: this.$session.get('deptId'),
        searchValue: '',//搜索内容
        fakeStatus: '123',//状态
        pageNum: 1,
        pageSize: 500,
      },//查询患者列表条件查询
      column: [
        { label: "患者", slotName: "patientName", 'min-width': 110 },
        {
          label: "性别", width: 60, formatter: (row => {
            let str = ''
            if (!isNull(row.sex)) {
              if (row.sex == 0) {
                str = '男'
              } else {
                str = '女'
              }
            }
            return str;
          })
        },
        { label: "年龄", prop: "age" },
        { label: "手机号", prop: "phone", width: 130, },
        {
          label: "患者类型", formatter: (row) => {
            return dictText(row.doctorVisit, doctorVisitList)
          }
        },
        { label: "状态", slotName: 'status', width: 80, align: 'left' },
        {
          label: "门诊类型", formatter: (row) => {
            return row.isIncrease ? `${ dictText(row.type, outpatientTypeList)}加号` : dictText(row.type, outpatientTypeList)
          }
        },
        { label: "挂号费", slotName: "price" },
        { label: "医生", prop: "doctorName" },
        { label: "就诊日期", prop: "schedulingTime" },
        { label: "号数", slotName: "registeredCode", align: 'left' },
        { label: "签到时间", prop: "signinTime" },
        { label: "挂号时段", prop: "timeQuantumName" },
        { label: "预计时段", prop: "signTimeQuantumName" },
        { label: "诊室", prop: "clinicName" }
      ],
      waitColumn: [
        { label: "序号", width: 60,formatter: (row) => { return row.rowNum  || '-'} },
        { label: "患者", slotName: "patientName" },
        {
          label: "性别", width: 60, formatter: (row => {
            let str = ''
            if (!isNull(row.sex)) {
              if (row.sex == 0) {
                str = '男'
              } else {
                str = '女'
              }
            }
            return str;
          })
        },
        { label: "年龄", prop: "age",width: 60 },
        { label: "手机号", prop: "phone", width: 130, },
        {
          label: "患者类型", formatter: (row) => {
            return dictText(row.doctorVisit, doctorVisitList)
          }
        },
        { label: "状态", slotName: 'waitStatus'},
        {
          label: "门诊类型", formatter: (row) => {
            return dictText(row.sourceType, outpatientTypeList)
          }
        },
        { label: "挂号费", slotName: "price" },
        { label: "医生", prop: "doctorName" },
        { label: "候补时间", formatter:(row=>{ return `${row.appointmentStartTime}-${row.appointmentEndTime}` })  },
        { label: "发起候补时间", prop: "initiateTime" },
      ],
      tableData: [],
      levelData: levelData,
      visibleObj: visibleObj,
      totalPriceTotal: 0,//挂号费总计
      currentLevelData: {},//显示在最上面弹框对象信息
      doctorSearchFrom: {
        doctorName: '',
        startTime: '',
        stopTime: '',
        deptId: this.$session.get('deptId')
      },//医生搜索参数
      doctorList: [],//医生列表
      currenDoctor: {
        doctorId: '',
        doctorName: ''
      },//当前选中医生
      dialogObj: {},//传递给子组件的数据
      currenDate: null,//当前激活日期
      statusList: registerStatusList,
      printOrderId: '',//打印订单id
      printDialogShow: false,//打印弹框
      dialogPrint: false, // 打印表单状态
      userDefaultPrint: true,//是否可以使用个人默认打印机
      deptDefaultPrint: true,//是否可以使用门店默认打印机
      defaultPrintList: {},//默认打印机对象
      isSian: false,//是否签到
      loadingText: '请稍等',
      searchAll: false,
      SMSDialogObj: {
        show: false,
      },
      waitStatus:{
        '0': { label: '待支付', color: '#FE8F1F',},
        '1': { label: '候补中', color: '#FE8F1F',},
        '2': { label: '候补成功', color: '#29C01B',},
        '3': { label: '候补失败', color: '#667182',},
        '4': { label: '候补取消', color: '#667182',},
        '5': { label: '已退号', color: '#667182', },
      },
      waitDialogObj:{
        show: false,
        info:{}
      },
      standbyNum:0
    }
  },
  //变量监听
  watch: {},
  computed: {
  },
  // 页面初始化
  created() {
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
    clearTimeout(this.timeoutId)

  },
  filters: {
    //过滤医生排班状态
    filterStatus(item) {
      let str = ''
      if (item.status == '0') {
        if (Utils.gt(item.surNum, 0)) {
          str = '挂号'
        } else {
          str = '加号'
        }
      } else {
        str = '停诊'
      }
      if (Utils.gt(moment(item.schedulingTime).valueOf(), moment().startOf('day').valueOf())) {
        str = '预约'
      }
      return str;
    },
    filterRegStatus(val) {
      return dictText(val, registerStatusList)
    },
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    /**
    * 滚动条分页
    */
    getMoreList() {
      console.log(1111);
      let that = this
      if (this.isLoadMore && !this.isMore) {
        that.isMore = true
        that.patinetSearchForm.pageNum += 1
        that.getRegisterList()
      }
    },
    /**
     * 搜索患者
     */
    searchRegisterList: debounce(function () {
      if (isNull(this.patinetSearchForm.searchValue)) {
        this.searchAll = false
        this.patinetSearchForm.fakeStatus = '123'
      } else {
        this.searchAll = true
        this.patinetSearchForm.fakeStatus = ''
      }
      this.getRegisterList()
    }, 300),
    /**
     * 刷新
     */
    refresh() {
      this.dialogVisible('registerDialog', false)
      this.dialogVisible('registerDetailDialog', false)
      this.getDoctorSchedulingList();
    },
    /**
     * 挂号
     */
    openRegister(item) {
      this.dialogObj = { ...item, currenDate: this.currenDate }
      this.dialogVisible('registerDialog', true)
    },
    /**
     * 关闭弹框
     */
    dialogVisible(name, bol) {
      // 隐藏取消支付中状态按钮
      this.showCancelPayBtn = false
      let visibleObj = this.visibleObj;
      name = name || this.currentLevelData.name;
      visibleObj[name] = bol != undefined ? bol : !visibleObj[name];
      this.$set(this, "visibleObj", visibleObj);
      this.setDialogLevel(name)
      this.getLevelData();
      // if (name == 'locksetDialog' && !bol) { this.getDoctorSchedulingList(); }
    },
    /**
     * 弹框确认
     */
    confirmUpdateData(data) {
      let currentLevelData = this.currentLevelData;
      currentLevelData.confirmfn && this[currentLevelData.confirmfn](data);
    },
    // 设置弹窗层级
    setDialogLevel(currentLevel) {
      let visibleObj = this.visibleObj;
      let levelData = this.levelData;
      let that = this;
      if (this.visibleObj[currentLevel]) {
        levelData.map(v => {
          // 设置当前层的level为1，其余visible为true的level依次递增
          // enter confirm操作的始终是level为1的dialog
          if (v.name == currentLevel) {
            v.level = 1
          } else if (that.visibleObj[v.name]) {
            v.level = Utils.bigNumber(v.level, '+', 1)
          }
        })
      } else {
        levelData.map(v => {
          // 当前dialog关闭，则设置level为0， 其余visible为true的level依次减一
          if (v.name == currentLevel) {
            v.level = 0
          } else if (that.visibleObj[v.name] && Utils.gt(v.level, 0)) {
            v.level = Utils.bigNumber(v.level, '-', 1)
          }
        })
      }

      this.$set(this, 'levelData', levelData)
    },
    // 获取当前层级 及其Data
    getLevelData() {
      let visibleObj = this.visibleObj;
      let levelData = this.levelData;
      let obj = {};
      let temp = Object.entries(visibleObj).filter((v, i) => {
        let currentLevel = levelData.find(vs => { return vs.name == v[0] })
        return (currentLevel && v[1] && v[0] != '' && Utils.eq(currentLevel.level, 1))
      });
      let name = temp && temp.length > 0 ? temp[0][0] : '';
      let currentLevelData = levelData.filter(v => {
        return v.name == name
      });
      if (!temp || temp.length == 0) {
        visibleObj[name] = true;
      }
      obj = {
        ...currentLevelData[0],
      }
      this.$set(this, 'visibleObj', visibleObj)
      this.$set(this, 'currentLevelData', obj)
    },
    /**
     * 挂号确认
     */
    registerConfirmfn(obj) {
      this.loading = true;
      obj.intoType = '1'
      registerAdd(obj).then(async res => {
        let { code, data } = res
        if (code == 200) {
          this.saveRelation(obj, data.registeredId)
          this.dialogObj = {
            ...this.dialogObj,
            price: data.price,
            registeredId: data.registeredId,
            ctOrderId: data.ctOrderId,
            clinicName: data.clinicName,
            schedulingTime: data.schedulingTime,
            timeName: data.timeName,
            timeQuantumName: data.timeQuantumName,
            registeredCode: data.registeredCode,
            doctorName: data.doctorName,
            phone: data.patientPhone,
            orderNumber:data.orderNumber,
            patientName:data.patientName,
            age:obj.year,
            doctorCode:data.doctorCode,
            channelType: data.channelType
          }
          this.dialogVisible('registerDialog', false)
          this.dialogVisible('locksetDialog', true)
          this.loading = false;
        } else {
          this.loading = false;
        }
      })

    },
    /**
     * 锁号确认
     */
    locksetFirmfn() {
      this.dialogVisible('chargeDialog', true)
    },
    /**
     * 好码齐支付
     */
    howmuchDialogFn(obj) {
      this.loading = true
      this.loadingText = '支付中，请稍后～'
      let ctOrderIds = []
      ctOrderIds[0] = this.dialogObj.ctOrderId
      let { payWay, userAuthCode, price } = obj;
      let preParams = {
        ctOrderIds,
        amount: price,
        payWay,
        attach: { userAuthCode }
      }
      payDTO.payFun(preParams).then(async res => {
        console.log(res, 22222);

        let { code, data } = res
        if (code == 200) {
          this.getConsumeMessage(data.attach.queueId)
        } else {
          this.loading = false
          this.dialogVisible('howmuchDialog', false);
          this.loadingText = '请稍后'
        }
      }).catch(err => {
        if (err.code === 500) {
          // 代表此订单正在收费中
          this.showCancelPayBtn = true
        }
        this.loading = false
        this.loadingText = '请稍后'
      })
    },

    /**
     * 关闭定时器并刷新
     */
    closeInterval() {
      clearTimeout(this.timeoutId1)
      clearTimeout(this.timeoutId2)
      this.dialogVisible('chargeDialog', false);
      this.dialogVisible('locksetDialog', false);
      this.dialogVisible('registerDetailDialog', false);
      this.dialogVisible('howmuchDialog', false);
      this.loadingText = '请稍后'
      this.loading = false
      if (this.isSian) {
        this.sign()
      } else {
        this.getDoctorSchedulingList();
        this.loading = false
      }
    },
    /**
     * 查询支付消息
     */
    getConsumeMessage(id) {
      this.loadingText = '等待支付结果'
      this.handleConsumeMessage(id)
      timeoutTimer('timeoutId2', () => {
        this.closeInterval()
      }, 5 * 60 * 1000)
    },
    /**
     * 执行查询消息
     */
    handleConsumeMessage(id) {
      CommonDTO.consumeMessage({ id }).then(async res => {
        if (res.code == 200) {
          let list = isNull(res.data) ? [] : res.data
          let defeatedObj = list.find(item => { return item.type == 1 && item.status == '2' }) //失敗消息
          let isEnd = list.some(item => { return item.type == -1 })
          if (!isNullObj(defeatedObj)) {
            this.$message.error(defeatedObj.text)
            this.closeInterval()
            return;
          }
          if (isEnd) {
            await getShareCoupon({ orderId: this.dialogObj.registeredId, type: 1 }).then((res => {
              if ((res.code == 200) && !isNull(res.data) && !isEmptyArray(res.data)) {
                this.$message.success("恭喜获得优惠券！");
              } else {
                this.$message.success("收费成功！");
              }
            }))
            this.closeInterval()
            return;
          }
          timeoutTimer('timeoutId1', () => {
            this.handleConsumeMessage(id)
          }, 1000)
        } else {
          this.closeInterval()
        }
      }).catch(err => {
        this.$message.error('支付超时')
        this.closeInterval()
      })

    },

    /**
     * 收费确认
     */
    async chargeFirmfn(obj) {
      this.loading = true
      let { payWay } = obj;
      let ctOrderIds = []
      ctOrderIds[0] = this.dialogObj.ctOrderId
      let preParams = {
        amount: this.dialogObj.price,
        ctOrderIds: ctOrderIds,
        payWay: payWay,
        deptId: this.$session.get('deptId'),
      }
      if (payWay == 1) {
        console.log(obj, 99999);
        this.loading = false
        this.dialogObj.doctorInfo = this.dialogObj
        this.dialogObj.patientInfo = { patientName: this.dialogObj.patientName,age:this.dialogObj.age }
        this.dialogObj.registerObj = { price: this.dialogObj.price, orderNumber: this.dialogObj.orderNumber }
        this.dialogObj.ctOrderIds = ctOrderIds
        this.dialogObj.diagnosisList = []
        this.dialogObj.diagnosis = ''
        this.dialogVisible('yibaoDialog', true)
      }else if (payWay == 3) {
        // 好码齐支付
        this.dialogVisible('howmuchDialog', true)
        this.loading = false
      } else if (payWay == 8) {
        this.loading = false
        this.SMSDialogObj.show = true
        this.SMSDialogObj.price = this.dialogObj.price
        this.SMSDialogObj.phone = this.dialogObj.phone
        this.$nextTick(async () => {
          let curAmount = await this.$refs.SMSDialog.getWalletAmount(this.dialogObj.phone)
          if (curAmount < this.dialogObj.price) {
            this.$message.error('会员钱包余额不足，请充值后继续操作')
          }
        })
      } else if (payWay == 12) {
        this.$refs['vipCardScan'].open()
        this.loading = false
      } else {
        payDTO.payFun(preParams).then(async res => {
          let { code, data } = res
          if (code == 200) {
            let time = await CommonDTO.getSystemTimeDTO()
            let obj = { orderPayNumber: data.orderPayNumber, paySuccess: '1', amount: this.dialogObj.price, payTime: this.$moment(time).format('YYYY-MM-DD HH:mm:ss') }
            payDTO.payCallback(obj).then(async result => {
              if (result.code == 200) {
                await getShareCoupon({ orderId: this.dialogObj.registeredId, type: 1 }).then((res => {
                  if ((res.code == 200) && !isNull(res.data) && !isEmptyArray(res.data)) {
                    this.$message.success("恭喜获得优惠券！");
                  } else {
                    this.$message.success("收费成功！");
                  }
                }))
                this.SMSDialogObj.show = false
                this.dialogVisible('chargeDialog', false);
                this.dialogVisible('locksetDialog', false);
                this.dialogVisible('registerDetailDialog', false);
                if (payWay == 3) this.dialogVisible('howmuchDialog', false);
                if (this.isSian) {
                  this.isSian = false
                  let { code, data } = await registerSignIn({ registeredId: this.dialogObj.registeredId })
                  if (code == 200) {
                    this.loading = false
                    this.print()
                  }
                } else {
                  this.getDoctorSchedulingList();
                  this.loading = false
                  this.$refs.SMSDialog.loading = false
                }
              } else {
                this.loading = false
                this.$refs.SMSDialog.loading = false
              }
            })
          } else {
            this.loading = false
            this.$refs.SMSDialog.loading = false
          }
        }).catch(err => {
          if (err.code === 500) {
            // 代表此订单正在收费中
            this.showCancelPayBtn = true
          }
          this.loading = false
        })
      }
    },

    async vipCardScanSuccess (code) {
      if (code) {
        const res = await getVipCardInfo({ vipCardNumber: code })
        if (res.code === 200) {
          if ([2, 3, 4].includes(res.data.status)) {
            let text = ''
            switch (res.data.status) {
              case 2:
                text = '该至尊卡已过期，暂不可用!'
                break
              case 3:
                text = '该至尊卡已被冻结，暂不可用!'
                break
              case 4:
                text = '该至尊卡未激活，暂不可用!'
                break
            }
            this.$confirm(text, '提示', {
              showConfirmButton: false,
              cancelButtonText: '关闭',
              type: 'warning'
            }).then(() => {}).catch(() => {})
            return
          }
          const balance = res.data.balance || 0
          if (balance < this.dialogObj.price) {
            this.$confirm(`余额不足，剩余金额${balance}`, '提示', {
              showConfirmButton: false,
              cancelButtonText: '关闭',
              type: 'warning'
            }).then(() => {}).catch(() => {})
            return
          }

          let ctOrderIds = []
          ctOrderIds[0] = this.dialogObj.ctOrderId
          let preParams = {
            amount: this.dialogObj.price,
            ctOrderIds: ctOrderIds,
            payWay: 12,
            deptId: this.$session.get('deptId'),
            attach: {
              vipCardNumber: res.data.vipCardNumber
            }
          }

          payDTO.payFun(preParams).then(async res => {
            let { code, data } = res
            if (code == 200) {
              let time = await CommonDTO.getSystemTimeDTO()
              let obj = { orderPayNumber: data.orderPayNumber, paySuccess: '1', amount: this.dialogObj.price, payTime: this.$moment(time).format('YYYY-MM-DD HH:mm:ss') }
              payDTO.payCallback(obj).then(async result => {
                if (result.code == 200) {
                  await getShareCoupon({orderId:  this.dialogObj.registeredId,type:1}).then((res=>{
                    if((res.code == 200) && !isNull(res.data) && !isEmptyArray(res.data)){
                      this.$message.success("恭喜获得优惠券！");
                    }else{
                      this.$message.success("收费成功！");
                    }
                  }))
                  this.SMSDialogObj.show = false
                  this.dialogVisible('chargeDialog', false);
                  this.dialogVisible('locksetDialog', false);
                  this.dialogVisible('registerDetailDialog', false);
                  if (this.isSian) {
                    this.isSian = false
                    let { code, data } = await registerSignIn({ registeredId: this.dialogObj.registeredId })
                    if (code == 200) {
                      this.loading = false
                      this.print()
                    }
                  } else {
                    this.getDoctorSchedulingList();
                    this.loading = false
                    this.$refs.SMSDialog.loading = false
                  }
                } else {
                  this.loading = false
                  this.$refs.SMSDialog.loading = false
                }
              })
            } else {
              this.loading = false
              this.$refs.SMSDialog.loading = false
            }
          }).catch(err => {
            if (err.code === 500) {
              // 代表此订单正在收费中
              this.showCancelPayBtn = true
            }
            this.loading = false
          })
        }
      }
    },

    // 获取支付订单号（用于取消支付中状态）
    async getPayOrderNum() {
      const params = {
        orderCombinedNum: this.dialogObj.orderCombinedNum,
        status: '3'
      }
      const res = await payDTO.getOrderPayNum(params)
      if (res.code === 200) {
        if (res.data.length > 0) {
          return res.data[0].orderPayNumber
        } else {
          this.showCancelPayBtn = false
          this.$message.error('数据已由其他用户更新，请刷新以查看最新信息')
        }
      }
      return ''
    },

    // 取消支付中的状态
    async cancelPayingStatusHandle() {
      let orderPayNumber = ''
      if (this.dialogObj.orderCombinedNum) {
        orderPayNumber = await this.getPayOrderNum()
      } else {
        let { code, data } = await getInfo({ registeredId: this.dialogObj.registeredId })
        if (code === 200) {
          this.dialogObj.orderCombinedNum = data.orderCombinedNum || ''
          orderPayNumber = await this.getPayOrderNum()
        }
      }
      if (!orderPayNumber) return
      msgboxWarning(this, {
        message: "支付出现问题，请先确认是否已扣款。若已扣款，请耐心等待支付结果通知。若未扣款，您可以取消此次支付。",
        confirmButtonText: "确定取消支付",
        cancelButtonText: "关闭弹窗",
        confirmFn: async () => {
          const params = {
            orderPayNumber: orderPayNumber || '',
            type: "1"
          }
          const res = await payDTO.cancelPayingStatus(params)
          if (res.code == 'success') {
            this.$message.success('取消成功')
            this.showCancelPayBtn = false
          } else {
            this.$message.error('取消失败')
          }
        },
        cancelFn: () => {
        }
      })
    },
    /**
     * 退款退号
     */
    refundMoenyRegister() {
      this.dialogVisible('returnComfirmDialog', true)
    },
    /**
     * 退款弹框
     */
    async refundFirmfn() {
      this.dialogVisible('refundDialog', false)
      this.dialogVisible('locksetDialog', false)
      this.dialogVisible('returnComfirmDialog', false)
    },
    /**
     * 退号确认
     */
    async returnComfirm() {
      this.dialogVisible('returnComfirmDialog', false)
      if (this.dialogObj.type == 5 || this.dialogObj.status == 0 || Utils.eq(this.dialogObj.finalPrice, 0)) {
        // 义诊或待付或金额为0
        let { code } = await registerCancel(this.dialogObj.registeredId);
        if (code == 200) {
          this.$message.success("取消挂号成功！");
          this.dialogVisible('refundDialog', false)
          this.dialogVisible('locksetDialog', false)
          this.dialogVisible('returnComfirmDialog', false)
          this.dialogVisible('locksetDialog', false);
          this.dialogVisible('registerDetailDialog', false);
          this.getDoctorSchedulingList();
          this.loading = false;
        }
      } else {
        // 非义诊，先退款后退号
        this.dialogVisible('refundDialog', true)

      }
    },
    /**
     * 点击表格每一项
     */
    async cellClick(row, column, cell, event) {
      if(this.patinetSearchForm.fakeStatus == '99'){
        this.waitDialogObj.show = true
        this.waitDialogObj.info = row
      }else{
        let { code, data } = await getInfo({ registeredId: row.registeredId })
        if (code == 200) {
          this.dialogObj = { ...this.dialogObj, ...data, referralDoctorList: [] }
          this.dialogVisible('registerDetailDialog', true)
        }
      }
    },
    /**
     * 切换上下月
     */
    changeMonth(obj) {
      let divObj = this.$refs.calendar.$refs
      for (let key in divObj) { if (!isEmptyArray(divObj[key])) divObj[key][0].innerText = '' }
    },
    /**
     * 获取当前激活的日期
     */
    getCurrenDate(date) {
      this.currenDate = date;
      this.doctorSearchFrom.startTime = date
      this.doctorSearchFrom.stopTime = date
      this.getDoctorSchedulingList();
    },
    /**
     * 获取某个医生这个月的排班列表
     * id 医生id
     */
    async getDoctorSchedulingListByMonth(id) {
      let obj = {
        doctorId: id,
        deptId: this.$session.get('deptId'),
        startTime: this.$moment(this.currenDate).startOf('month').format('YYYY-MM-DD'),
        stopTime: this.$moment(this.currenDate).endOf('month').format('YYYY-MM-DD'),
      }
      let { code, rows } = await doctorSchedulingList(obj);
      if (code == 200 && !isEmptyArray(rows)) {
        rows.forEach(item => {
          let time = this.$moment(item.schedulingTime).startOf('day').valueOf()
          if (item.status == -2) {
            this.$refs.calendar.$refs[`day${time}`][0].innerText = `停诊`
          } else if (Utils.le(this.$moment().startOf('day').valueOf(), time)) {
            this.$refs.calendar.$refs[`day${time}`][0].innerText = `余${item.surNum}`
          }
        })
      }
    },

    /**
     * 获取医生排班列表
     */
    async getDoctorSchedulingList() {
      let { code, rows } = await doctorSchedulingList(this.doctorSearchFrom);
      this.getRegisterStatusNum();
      if (code == 200) {
        this.doctorList = rows;
        if (!isEmptyArray(rows)) {
          let regNum = 0;
          let staySeeNum = 0;
          let staySignNum = 0;
          let surNum = 0
          let standbyNum = 0
          // 计算每项数据的总和
          rows.forEach(item => {
            regNum = _.add(regNum, item.regNum);
            staySeeNum = _.add(staySeeNum, item.staySeeNum);
            staySignNum = _.add(staySignNum, item.staySignNum);
            surNum = _.add(surNum, item.surNum);
            standbyNum = _.add(standbyNum, item.standbyNum);
          })
          if (isNull(this.doctorSearchFrom.doctorName)) {
            this.doctorList.unshift({
              doctorId: '',
              status: '0',
              doctorName: '全部医生',
              regNum,
              staySeeNum,
              staySignNum,
              surNum,
              standbyNum,
              schedulingTime: rows[0].schedulingTime,
            })
          }
          this.currenDoctor = isNullObj(rows[0]) ? rows[0] : this.currenDoctor
          if (!isNull(this.currenDoctor.doctorId)) { this.getDoctorSchedulingListByMonth(this.currenDoctor.doctorId) }
          this.$nextTick(() => {
            let divObj = this.$refs.calendar.$refs
            for (let key in divObj) {
              if (!isEmptyArray(divObj[key])) divObj[key][0].innerText = ''
            }
          })
        } else {
          this.tableData = []
        }
        this.getRegisterList()
      }
    },
    /**
     * 医生搜索
     */
    doctorSearch: debounce(function () {
      this.getDoctorSchedulingList()
    }, 300),
    /**
     * 比较传入的时间和今天00:00:00的时间
     */
    computedDate(date) {
      return Utils.lt(this.$moment(date).valueOf(), this.$moment().startOf('day').valueOf()) ? false : true
    },
    /**
     * 切换医生
     */
    changeDoctor(item) {
      this.currenDoctor = item
      if (!isNull(item.doctorId)) {
        this.getDoctorSchedulingListByMonth(item.doctorId)
      }
      let divObj = this.$refs.calendar.$refs
      for (let key in divObj) { if (!isEmptyArray(divObj[key])) divObj[key][0].innerText = '' }
      this.getRegisterList();
      this.getRegisterStatusNum()
    },
    /**
     * 查询挂号单数量
     */
    async getRegisterStatusNum() {
      let params = {
        deptId: this.$session.get('deptId'),
        doctorId: this.currenDoctor.doctorId,
        startTime: this.currenDate,
        stopTime: this.currenDate,
      }
      let { code, data } = await getRegisterStatusNum(params);
      if (code == 200) {
        this.standbyNum = data.standbyNum
        // if(this.patinetSearchForm.fakeStatus != '99'){
          this.statusList.forEach(item => {
            for (let key in data) {
              if (item.numLabel == key) {
                item.num = data[key]
              }
              if (item.amountLabel == key) {
                item.amount = data[key]
              }
            }
            // 处理取消数据
            if (item.value == '-1') {
              item.num = _.add(data.cancelNum || 0, data.runOverTimeNum || 0)
              item.amount = this.$bigNumber(data.cancelAmount || 0, '+', data.runOverTimeAmount || 0)
            }
            // 处理已签数据 已签 = 待诊 + 已诊
            if (item.value == '23') {
              item.num = _.add(data.staySeeNum || 0, data.alreadySeeNum || 0)
              item.amount = this.$bigNumber(data.staySeeAmount || 0, '+', data.alreadySeeAmount || 0)
            }
            // 处理已约数据 已约 = 待签 + 待诊 + 已诊
            if (item.value == '123') {
              let numArr = [data.staySignNum || 0, data.staySeeNum || 0, data.alreadySeeNum || 0]
              let amountArr = [data.staySignAmount || 0, data.staySeeAmount || 0, data.alreadySeeAmount || 0]
              item.num = Utils.sum(numArr)
              item.amount = Utils.sum(amountArr)
            }
          })
          this.totalPriceTotal = this.statusList.find(v => { return v.value == this.patinetSearchForm.fakeStatus }) && this.statusList.find(v => { return v.value == this.patinetSearchForm.fakeStatus }).amount || 0
        // }
      }
    },
    /**
     * 查询挂号列表
     */
    async getRegisterList() {
      this.tableData = []
      let status = []
      let params = {
        ...this.patinetSearchForm,
        doctorId: this.currenDoctor.doctorId,
        startTime: this.currenDate,
        stopTime: this.currenDate,
      }
      if (this.searchAll) {
        params.startTime = this.$moment(this.currenDate).subtract(1, 'years').format('YYYY-MM-DD')
        params.stopTime = this.$moment(this.currenDate).add(1, 'month').format('YYYY-MM-DD')
        status = ['1', '2', '3', '-3', '-2', '0', '-1', '-5']
      } else {
        params.startTime = this.currenDate
        params.stopTime = this.currenDate
        if (this.patinetSearchForm.fakeStatus == '23') {
          status = ['2', '3']
        } else if (this.patinetSearchForm.fakeStatus == '123') {
          status = ['1', '2', '3']
        } else if (this.patinetSearchForm.fakeStatus == '-1') {
          status = ['-1', '-5']
        } else {
          status[0] = this.patinetSearchForm.fakeStatus
        }
      }
      params.status = status
      if (this.patinetSearchForm.fakeStatus == '99') {
        let { code, data } = await getStandbyList(params)
        if (code == 200) {
          this.isLoadMore = Utils.lt(data.length, this.patinetSearchForm.pageSize) ? false : true
          this.isMore = false
          let total = 0
          data.forEach(item => {
            item.schedulingTime = this.$moment(item.schedulingTime).format('YYYY-MM-DD')
            total = this.$bigNumber(total, '+', item.price)
          })
          console.log(data,1111);
          
          this.tableData = data
        }
      } else {
        let { code, rows } = await getRegisterList(params)
        if (code == 200) {
          this.isLoadMore = Utils.lt(rows.length, this.patinetSearchForm.pageSize) ? false : true
          this.isMore = false
          let total = 0
          rows.forEach(item => {
            total = this.$bigNumber(total, '+', item.price)
          })
          this.tableData = rows
        }
      }

    },
    /**
     * 切换状态
     */
    sttusChange(val) {
      if (val != '99') {
        let obj = this.statusList.find(item => { return item.value == val })
        this.totalPriceTotal = obj.amount || 0
      }
      this.getRegisterList()
    },
    /**
     * 签到并打印
     */
    async signAndCall() {
      this.loading = true
      let { code, data } = await registerSignIn({ registeredId: this.dialogObj.registeredId })
      if (code == 200) {
        this.loading = false
        this.getDoctorSchedulingList();
        this.print()
      } else {
        this.loading = false
      }

    },
    /**
     * 打印
     */
    print() {
      this.printOrderId = this.dialogObj.registeredId
      this.$nextTick(() => {
        this.$refs.printDia.useDefaultPrint()
      })
    },
    setPrintDiaShow() {
      this.printDialogShow = true
    },
    /**
     * 签到
     */
    async sign() {
      this.loading = true
      this.isSian = false
      let { code, data } = await registerSignIn({ registeredId: this.dialogObj.registeredId })
      if (code == 200) {
        this.$message.success('签到成功');
        this.dialogVisible('locksetDialog', false);
        this.dialogVisible('registerDetailDialog', false);
        this.getDoctorSchedulingList();
        this.loading = false
      } else {
        this.loading = false
      }
    },
    /**
      * 打印完成
      */
    printSuccess() {
      this.printDialogShow = false;
      this.dialogVisible('locksetDialog', false);
      this.dialogVisible('registerDetailDialog', false);
      this.getDoctorSchedulingList();
    },
    /**
    * 取消打印
    */
    closePrintPrescription() {
      this.printDialogShow = false
    },
    /**
     * 退号
     */
    async refundRegister() {
      this.dialogVisible('returnComfirmDialog', true)
    },
    /**
     * 收费并签到
     */
    async chargeAndSign(obj) {
      this.isSian = true
      this.chargeFirmfn(obj)
    },
    /**
     * 查看今日
     */
    toDay() {
      this.$refs.calendar.currentId = this.$moment().startOf('day').valueOf();
      this.$refs.calendar.init()
      this.getCurrenDate(this.$moment().format('YYYY-MM-DD'));

    },
    /**
     * 关闭锁号弹框
     */
    closeLokset() {
      this.dialogVisible('locksetDialog')
      this.getDoctorSchedulingList()
    },
    SMSDialogClose() {
      // this.$refs.pricingChargeDialog[0].loading = false
      this.SMSDialogObj.show = false
    },
    //短信验证确定
    smsVerificationConfirm(obj) {
      let { phone, price, code, curAmount } = obj
      if (curAmount < price) {
        this.$message.error('会员钱包余额不足，请充值后继续操作')
        return
      }
      this.$refs.SMSDialog.loading = true
      let ctOrderIds = []
      ctOrderIds[0] = this.dialogObj.ctOrderId
      let preParams = {
        ctOrderIds,
        amount: price,
        payWay: '8',
        attach: { phone, smsCode: code }
      }
      payDTO.payFun(preParams).then(async res => {
        let { code, data } = res
        if (code == 200) {
          let time = await CommonDTO.getSystemTimeDTO()
          let obj = { orderPayNumber: data.orderPayNumber, paySuccess: '1', amount: this.dialogObj.price, payTime: this.$moment(time).format('YYYY-MM-DD HH:mm:ss') }
          payDTO.payCallback(obj).then(async result => {
            if (result.code == 200) {
              this.SMSDialogObj.show = false
              await getShareCoupon({ orderId: this.dialogObj.registeredId, type: 1 }).then((res => {
                if ((res.code == 200) && !isNull(res.data) && !isEmptyArray(res.data)) {
                  this.$message.success("恭喜获得优惠券！");
                } else {
                  this.$message.success("收费成功！");
                }
              }))
              this.dialogVisible('chargeDialog', false);
              this.dialogVisible('locksetDialog', false);
              this.dialogVisible('registerDetailDialog', false);
              if (this.isSian) {
                this.isSian = false
                let { code, data } = await registerSignIn({ registeredId: this.dialogObj.registeredId })
                if (code == 200) {
                  this.loading = false
                  this.print()
                }
              } else {
                this.getDoctorSchedulingList();
                this.loading = false
              }
            } else {
              this.loading = false
              this.$refs.SMSDialog.loading = false
            }
          })
        } else {
          this.loading = false
          this.$refs.SMSDialog.loading = false
        }
      }).catch(err => {
        if (err.code === 500) {
          // 代表此订单正在收费中
          this.showCancelPayBtn = true
        }
        this.loading = false
        this.$refs.SMSDialog.loading = false
      })
    },
    async saveRelation(obj, id) {
      let { patientId, doctorId, referrerPhone, sourceId, referrerDoctorId, isHasRelation, referrerUserId } = obj
      if (isNull(sourceId) || isHasRelation) return;
      if (isHasRelation) { return }
      let params = {
        patientId, doctorId, orderId: id, sourceId, referrer: '',
      }
      if (sourceId == 9) { params.referrer = referrerPhone }
      if (sourceId == 10) { params.referrer = referrerDoctorId }
      if (sourceId == 11) { params.referrer = referrerUserId }
      let { code, data } = await saveRelation(params)
    },
    waitDetailClose(refresh){
      this.waitDialogObj.show = false
      if(refresh){
        this.getRegisterList()
      }
    },
    /**
     * 医保支付
     */
    async yibaoPay(obj) {
      try {
        this.loading = true
        let { orderPayNumber, price, paySuccess, attach } = obj
        let time = await CommonDTO.getSystemTimeDTO()
        let params = {
          orderPayNumber,
          payTime: this.$moment(time).format('YYYY-MM-DD HH:mm:ss'),
          paySuccess,
          amount: price,
          attach: isNull(attach) ? {} : attach
        }
        payDTO.payCallback(params).then(res => {
          if (res.code == 200) {
            this.dialogVisible('yibaoDialog', false)
            this.$message.success("收费成功！");
            this.dialogVisible('chargeDialog', false);
            this.dialogVisible('locksetDialog', false);
            this.dialogVisible('registerDetailDialog', false);
            if (this.isSian) {
              this.sign()
            } else {
              this.getDoctorSchedulingList();
              this.loading = false
            }
          } else {
            this.dialogVisible('yibaoDialog', false)
            this.loading = true
          }
        }).catch(err => {
          this.dialogVisible('yibaoDialog', false)
          this.loading = true
        })
      } catch (error) {
        this.dialogVisible('yibaoDialog', false)
        this.loading = true
      }
    },
    changeRegister(obj){
      this.dialogObj = {...obj,sourceType:'change' }
      this.dialogVisible('registerDialog', true)
    }
  },
}
</script>
<style lang="less" scoped src="./register.less"></style>